/**
 * ForaVida — Lucide icon bundle
 *
 * Icon set tree-shaken from the Lucide ESM package. Add new icons here
 * alphabetically and run `npm run build` to refresh the IIFE bundle.
 *
 * Total: 252 unique icons (Lucide 0.563.x).
 */

import { createIcons } from 'lucide';
import {
  Activity,
  AlertCircle,
  AlertTriangle,
  AlignHorizontalJustifyCenter,
  Anchor,
  Armchair,
  ArrowDown,
  ArrowDownToLine,
  ArrowLeftRight,
  ArrowRight,
  ArrowRightLeft,
  ArrowUp,
  ArrowUpRight,
  Award,
  Baby,
  BadgeCheck,
  BadgeEuro,
  Ban,
  Banknote,
  Battery,
  Blinds,
  Blocks,
  Bolt,
  BookOpen,
  Box,
  BrickWall,
  Briefcase,
  Bug,
  Building,
  Building2,
  Cable,
  Calculator,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  Camera,
  Car,
  Check,
  CheckCircle,
  CheckCircle2,
  CheckSquare,
  ChefHat,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  ChevronsUp,
  Circle,
  CircleDot,
  CircleSlash,
  Citrus,
  ClipboardCheck,
  Clock,
  Cloud,
  CloudDrizzle,
  CloudLightning,
  CloudRain,
  CloudRainWind,
  CloudSun,
  Coffee,
  Cog,
  Coins,
  Columns,
  Columns2,
  Columns3,
  Columns4,
  Compass,
  CornerDownRight,
  CornerRightDown,
  Cpu,
  CreditCard,
  Crosshair,
  Crown,
  DoorClosed,
  DoorOpen,
  Drill,
  Droplet,
  DropletOff,
  Droplets,
  Dumbbell,
  Euro,
  Expand,
  Eye,
  EyeOff,
  Factory,
  Feather,
  Fence,
  FileCheck,
  FileSearch,
  FileText,
  FileWarning,
  Flame,
  Flower,
  Flower2,
  FolderCheck,
  Frame,
  Gem,
  GitBranch,
  GitCommitHorizontal,
  GitCompare,
  GitMerge,
  GlassWater,
  Globe,
  Grape,
  Grid,
  Grid2x2,
  Grid3x3,
  GripHorizontal,
  Hammer,
  Handshake,
  HardHat,
  Headphones,
  Headset,
  Heart,
  Home,
  Hourglass,
  House,
  Image,
  Info,
  Lamp,
  LampFloor,
  Landmark,
  Laptop,
  Layers,
  Layers2,
  Layers3,
  Layout,
  LayoutGrid,
  Leaf,
  Lightbulb,
  LineChart,
  Link,
  ListChecks,
  Lock,
  Mail,
  MailCheck,
  Map,
  MapPin,
  Maximize,
  Maximize2,
  MessageCircle,
  Mic,
  Minimize,
  Minimize2,
  Minus,
  MinusCircle,
  MinusSquare,
  Mountain,
  MousePointerClick,
  Move,
  MoveDown,
  MoveHorizontal,
  MoveRight,
  MoveUp,
  MoveVertical,
  Newspaper,
  Nut,
  Package,
  PackageSearch,
  PaintBucket,
  Paintbrush,
  Palette,
  PanelLeftOpen,
  PanelRightClose,
  PanelRightOpen,
  PanelTop,
  PanelTopOpen,
  PanelsLeftBottom,
  PanelsTopLeft,
  Pencil,
  Percent,
  Phone,
  PiggyBank,
  Pin,
  PlayCircle,
  Plug,
  Plus,
  PlusCircle,
  Puzzle,
  Radio,
  RailSymbol,
  Receipt,
  RectangleVertical,
  Recycle,
  RefreshCcw,
  RefreshCw,
  Repeat,
  Rotate3d,
  RotateCcw,
  RotateCw,
  Route,
  Rows3,
  Ruler,
  ScanLine,
  ScanSearch,
  Scissors,
  Settings,
  Settings2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Shirt,
  ShoppingCart,
  Shrub,
  Sliders,
  SlidersHorizontal,
  Smartphone,
  Snowflake,
  Sofa,
  SolarPanel,
  Sparkles,
  Split,
  SprayCan,
  Sprout,
  Square,
  SquareAsterisk,
  SquareDashed,
  SquareStack,
  Star,
  Store,
  Sun,
  SunDim,
  Sunrise,
  Sunset,
  Tag,
  Target,
  Tent,
  Thermometer,
  ThermometerSnowflake,
  ThermometerSun,
  Timer,
  TimerReset,
  ToggleRight,
  TreePine,
  Trees,
  TrendingUp,
  Triangle,
  Truck,
  Umbrella,
  UserCheck,
  Users,
  Utensils,
  Video,
  Volume2,
  VolumeX,
  Wallet,
  Waves,
  Weight,
  Wind,
  Wine,
  Wrench,
  Zap,
} from 'lucide';

const refresh = () => {
  createIcons({
    icons: {
      Activity,
      AlertCircle,
      AlertTriangle,
      AlignHorizontalJustifyCenter,
      Anchor,
      Armchair,
      ArrowDown,
      ArrowDownToLine,
      ArrowLeftRight,
      ArrowRight,
      ArrowRightLeft,
      ArrowUp,
      ArrowUpRight,
      Award,
      Baby,
      BadgeCheck,
      BadgeEuro,
      Ban,
      Banknote,
      Battery,
      Blinds,
      Blocks,
      Bolt,
      BookOpen,
      Box,
      BrickWall,
      Briefcase,
      Bug,
      Building,
      Building2,
      Cable,
      Calculator,
      Calendar,
      CalendarCheck,
      CalendarClock,
      CalendarDays,
      Camera,
      Car,
      Check,
      CheckCircle,
      CheckCircle2,
      CheckSquare,
      ChefHat,
      ChevronDown,
      ChevronRight,
      ChevronUp,
      ChevronsUp,
      Circle,
      CircleDot,
      CircleSlash,
      Citrus,
      ClipboardCheck,
      Clock,
      Cloud,
      CloudDrizzle,
      CloudLightning,
      CloudRain,
      CloudRainWind,
      CloudSun,
      Coffee,
      Cog,
      Coins,
      Columns,
      Columns2,
      Columns3,
      Columns4,
      Compass,
      CornerDownRight,
      CornerRightDown,
      Cpu,
      CreditCard,
      Crosshair,
      Crown,
      DoorClosed,
      DoorOpen,
      Drill,
      Droplet,
      DropletOff,
      Droplets,
      Dumbbell,
      Euro,
      Expand,
      Eye,
      EyeOff,
      Factory,
      Feather,
      Fence,
      FileCheck,
      FileSearch,
      FileText,
      FileWarning,
      Flame,
      Flower,
      Flower2,
      FolderCheck,
      Frame,
      Gem,
      GitBranch,
      GitCommitHorizontal,
      GitCompare,
      GitMerge,
      GlassWater,
      Globe,
      Grape,
      Grid,
      Grid2x2,
      Grid3x3,
      GripHorizontal,
      Hammer,
      Handshake,
      HardHat,
      Headphones,
      Headset,
      Heart,
      Home,
      Hourglass,
      House,
      Image,
      Info,
      Lamp,
      LampFloor,
      Landmark,
      Laptop,
      Layers,
      Layers2,
      Layers3,
      Layout,
      LayoutGrid,
      Leaf,
      Lightbulb,
      LineChart,
      Link,
      ListChecks,
      Lock,
      Mail,
      MailCheck,
      Map,
      MapPin,
      Maximize,
      Maximize2,
      MessageCircle,
      Mic,
      Minimize,
      Minimize2,
      Minus,
      MinusCircle,
      MinusSquare,
      Mountain,
      MousePointerClick,
      Move,
      MoveDown,
      MoveHorizontal,
      MoveRight,
      MoveUp,
      MoveVertical,
      Newspaper,
      Nut,
      Package,
      PackageSearch,
      PaintBucket,
      Paintbrush,
      Palette,
      PanelLeftOpen,
      PanelRightClose,
      PanelRightOpen,
      PanelTop,
      PanelTopOpen,
      PanelsLeftBottom,
      PanelsTopLeft,
      Pencil,
      Percent,
      Phone,
      PiggyBank,
      Pin,
      PlayCircle,
      Plug,
      Plus,
      PlusCircle,
      Puzzle,
      Radio,
      RailSymbol,
      Receipt,
      RectangleVertical,
      Recycle,
      RefreshCcw,
      RefreshCw,
      Repeat,
      Rotate3d,
      RotateCcw,
      RotateCw,
      Route,
      Rows3,
      Ruler,
      ScanLine,
      ScanSearch,
      Scissors,
      Settings,
      Settings2,
      Shield,
      ShieldAlert,
      ShieldCheck,
      Shirt,
      ShoppingCart,
      Shrub,
      Sliders,
      SlidersHorizontal,
      Smartphone,
      Snowflake,
      Sofa,
      SolarPanel,
      Sparkles,
      Split,
      SprayCan,
      Sprout,
      Square,
      SquareAsterisk,
      SquareDashed,
      SquareStack,
      Star,
      Store,
      Sun,
      SunDim,
      Sunrise,
      Sunset,
      Tag,
      Target,
      Tent,
      Thermometer,
      ThermometerSnowflake,
      ThermometerSun,
      Timer,
      TimerReset,
      ToggleRight,
      TreePine,
      Trees,
      TrendingUp,
      Triangle,
      Truck,
      Umbrella,
      UserCheck,
      Users,
      Utensils,
      Video,
      Volume2,
      VolumeX,
      Wallet,
      Waves,
      Weight,
      Wind,
      Wine,
      Wrench,
      Zap,
    },
  });
};

// Re-hydration hook for [data-lucide] markup injected after the initial
// pass (e.g. FacetWP AJAX results — see foravida-facetwp.js). Uses the
// exact same icon map as the DOMContentLoaded run; adding an icon still
// requires updating BOTH the import list and the map above.
window.fvIcons = { refresh };

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', refresh);
} else {
  // Host-level script deferral can push execution past DOMContentLoaded.
  refresh();
}
